import {
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  useToast,
  Text,
  Box,
  HStack,
  VStack,
  Flex,
} from "@chakra-ui/react";
import React from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useIntl } from "react-intl";
import { put, deleteMethod } from "src/api";
import SharedStatusBadge from "./SharedStatusBadge";

const SharedUserItem = ({
  sharedItem,
  setUsersList,
  showOptions,
  sharedStatus,
  sharedDate,
}) => {
  const toast = useToast();
  const { formatMessage } = useIntl();

  const onRemove = (id) => {
    deleteMethod(`/shared/${id}`).then((res: any) => {
      if (res.success) {
        toast({
          title: formatMessage({ id: "saved" }),
          status: "success",
          duration: 4000,
        });
        setUsersList((users) => users.filter((user) => user.id !== id));
      } else {
        toast({
          title: formatMessage({ id: "errorOnSaving" }),
          status: "error",
          duration: 4000,
        });
      }
    });
  };

  const changePermission = (permission: string, entityId: number) => {
    put(`/shared/${entityId}`, { permission }).then((res) => {
      if (res.accessor.id) {
        toast({
          title: formatMessage({ id: "saved" }),
          status: "success",
          duration: 4000,
        });
        setUsersList((entitys) => {
          return entitys.map((entity) => {
            if (entity.id === entityId) {
              return { ...entity, permission };
            }
            return entity;
          });
        });
      }
    });
  };

  return (
    <Box
      bg="gray.50"
      borderRadius="lg"
      p={4}
      border="1px solid"
      borderColor="gray.100"
      sx={{
        backgroundColor: "#f0f0f0",
      }}
    >
      <Flex justify="space-between" align="flex-start">
        <VStack align="flex-start" spacing={1} flex={1}>
          <Text
            fontSize="14px"
            fontWeight="600"
            color="gray.900"
            lineHeight="1.2"
          >
            {sharedItem.accessor.email}
          </Text>
          <Text fontSize="13px" color="gray.600" lineHeight="1.2">
            {sharedItem.accessor.name || "User"}
          </Text>
          <HStack spacing={2} align="center" mt={1}>
            <Text fontSize="12px" color="gray.500">
              {sharedDate}
            </Text>
          </HStack>
        </VStack>

        <HStack spacing={2} align="center">
          <SharedStatusBadge status={sharedStatus} />
          <IconButton
            color="gray.400"
            _hover={{ color: "red.500" }}
            onClick={() => onRemove(sharedItem.id)}
            fontSize="16px"
            variant="ghost"
            aria-label="delete"
            size="sm"
            icon={<RiDeleteBin6Line />}
          />
        </HStack>
      </Flex>

      {showOptions && (
        <Box mt={3} pt={3} borderTop="1px solid" borderTopColor="gray.200">
          <RadioGroup
            onChange={(e: any) => {
              changePermission(e, sharedItem.id);
            }}
            defaultValue={sharedItem.permission}
          >
            <Stack direction="row" spacing={4}>
              <Radio value="read" size="sm">
                <Text fontSize="13px">{formatMessage({ id: "readOnly" })}</Text>
              </Radio>
              <Radio value="update" size="sm">
                <Text fontSize="13px">
                  {formatMessage({ id: "readAndUpdate" })}
                </Text>
              </Radio>
            </Stack>
          </RadioGroup>
        </Box>
      )}
    </Box>
  );
};

export default SharedUserItem;
